<body>
  <!----------------------------------------------------------------------------------------->
  <section class="mb-5">
    <a href="javascript:" id="return-to-top"
      ><img
        src="https://img.icons8.com/metro/26/ffffff/sort-up.png"
        class="top"
        alt="sort-up"
    /></a>
    <div class="container-fluid section-first">
      <div class="row justify-content-center">
        <div class="col-lg-3 text-center">
          <div class="logo">
            <img
              src="{{ onPassiveBaseUrl }}onpassive(jan-1)/assets/image/logo.png"
              alt="logo"
            />
          </div>
        </div>
        <div class="col-lg-7 text-right">
          <div class="social-img">
            <a
              href="https://www.facebook.com/ONPASSIVE/ONPASSIVE"
              target="_blank"
              rel="noopener"
              title="Facebook"
            >
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(jan-1)/assets/image/icon/fb.png"
                class="icon"
                alt="facebook"
              />
            </a>
            <a
              href="https://twitter.com/ONPASSIVE"
              target="_blank"
              rel="noopener"
              title="Twitter"
            >
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(jan-1)/assets/image/icon/twitter.png"
                class="icon"
                alt="Twitter"
              />
            </a>
            <a
              href="https://www.instagram.com/ONPASSIVE/"
              target="_blank"
              rel="noopener"
              title="Instagram"
            >
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(jan-1)/assets/image/icon/insta.png"
                class="icon"
                alt="Instagram"
              />
            </a>
            <a
              href="https://www.youtube.com/c/ONPASSIVEc/ONPASSIVE"
              target="_blank"
              rel="noopener"
              title="Youtube"
            >
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(jan-1)/assets/image/icon/youtube.png"
                class="icon"
                alt="Youtube"
              />
            </a>
            <a
              href="https://www.linkedin.com/company/onpassiveofficial/company/onpassiveofficial"
              target="_blank"
              rel="noopener"
              title="LinkedIn"
            >
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(jan-1)/assets/image/icon/in.png"
                class="icon"
                alt="LinkedIn"
              />
            </a>
            <a
              href="https://onpassive.com/blog"
              target="_blank"
              rel="noopener"
              title="ONPASSIVE Blog"
            >
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(jan-1)/assets/image/icon/blog.png"
                class="blogicon"
                alt="blog"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid section-second">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="lanch">
            <img
              src="{{ onPassiveBaseUrl }}onpassive(jan-1)/assets/image/l.png"
              class="swingimage l"
              alt="1"
            />
            <img
              src="{{ onPassiveBaseUrl }}onpassive(jan-1)/assets/image/a.png"
              class="swingimage a"
              alt="a"
            />
            <img
              src="{{ onPassiveBaseUrl }}onpassive(jan-1)/assets/image/u.png"
              class="swingimage u"
              alt="u"
            />
            <img
              src="{{ onPassiveBaseUrl }}onpassive(jan-1)/assets/image/n.png"
              class="swingimage n"
              alt="n"
            />
            <img
              src="{{ onPassiveBaseUrl }}onpassive(jan-1)/assets/image/c.png"
              class="swingimage c"
              alt="c"
            />
            <img
              src="{{ onPassiveBaseUrl }}onpassive(jan-1)/assets/image/h.png"
              class="swingimage h"
              alt="h"
            />
            <img
              src="{{ onPassiveBaseUrl }}onpassive(jan-1)/assets/image/i.png"
              class="swingimage i"
              alt="i"
            />
            <img
              src="{{ onPassiveBaseUrl }}onpassive(jan-1)/assets/image/n1.png"
              class="swingimage n1"
              alt="n1"
            />
            <img
              src="{{ onPassiveBaseUrl }}onpassive(jan-1)/assets/image/g.png"
              class="swingimage g"
              alt="g"
            />
            <img
              src="{{ onPassiveBaseUrl }}onpassive(jan-1)/assets/image/s.png"
              class="swingimage s"
              alt="s"
            />
            <img
              src="{{ onPassiveBaseUrl }}onpassive(jan-1)/assets/image/o.png"
              class="swingimage o"
              alt="o"
            />
            <img
              src="{{ onPassiveBaseUrl }}onpassive(jan-1)/assets/image/o1.png"
              class="swingimage o1"
              alt="o1"
            />
            <img
              src="{{ onPassiveBaseUrl }}onpassive(jan-1)/assets/image/n2.png"
              class="swingimage n2"
              alt="n2"
            />
            <h1 class="ml13 text-white text-center">HAPPY NEW YEAR</h1>
          </div>
        </div>
        <canvas id="canvas"></canvas>
      </div>
    </div>
    <div class="container-fluid section-third">
      <div class="row justify-content-center">
        <div class="col-lg-10 text-center">
          <h1 class="ml14">
            <span class="text-wrapper">
              <span class="letters">ONPASSIVE Is Where You Register!</span>
              <span class="line"></span>
            </span>
          </h1>
          <p class="font1">
            The clock is ticking, with just a blink of an eye another year
            passed by. Don't think about the opportunities that you have missed,
            the New Year is unwritten for you. Make sure you make it count. With
            ONPASSIVE you can fill 2020 with beautiful moments and hopes if you
            are craving for something new for a beautiful life ahead.
          </p>
          <div class="row justify-content-center">
            <div class="col-lg-8">
              <div class="video-box">
                <video
                  id="my-video"
                  class="
                    video-js video-size
                    w-100
                    h-auto
                    my-video-dimensions
                    shadow
                  "
                  controls
                  preload="auto"
                  poster="{{ myLinksS3URL }}images/Image0231.png"
                  data-setup="{}"
                  autoplay="true"
                  muted
                >
                  <source
                    src="{{
                      myLinksS3URL
                    }}videos/Onpassive_launching_page_video2.mp4"
                    type="video/mp4"
                  />
                </video>
              </div>
              <a
                href="/registration/user?reg={{ userId }}"
                name="regform"
                target="_blank"
                rel="noopener"
                class="button fire mt-5"
                >BECOME A FOUNDER NOW</a
              >
            </div>
            <div class="col-lg-12"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid section-fourth">
      <div class="doll1">
        <img
          src="{{ onPassiveBaseUrl }}onpassive(jan-1)/assets/image/doll.png"
          class="doll2"
          alt="doll"
        />
        <img
          src="{{ onPassiveBaseUrl }}onpassive(jan-1)/assets/image/doll1.png"
          class="doll"
          alt="doll1"
        />
      </div>
      <div class="copy-right text-center">
        &copy; 2022 ONPASSIVE - All Rights Reserved
      </div>
    </div>
  </section>
  <!----------------------------------------------------------------------------------------->
</body>
